export const MARKER_COLORS = [
    'rgb(238,32,77)',
    'rgb(255,117,56)',
    'rgb(31,117,254)',
    'rgb(76,183,165)',
    'rgb(28,172,120)',
    'rgb(146,110,174)',
    'rgb(130,142,132)',
];
